import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { FiPlus } from 'react-icons/fi';
import SectionHead from './SectionHead';
import { faqs as defaultFaqs } from '../data/site';

const FAQ = ({
  items = defaultFaqs,
  eyebrow = 'FAQ',
  title = 'Questions, answered',
  subtitle = 'Can’t find what you’re looking for? Talk to us directly.',
  alt = false
}) => {
  const [openIndex, setOpenIndex] = useState(0);

  return (
    <section className={`section ${alt ? 'section-alt' : ''}`}>
      <div className="container faq-layout">
        <div className="faq-intro">
          <SectionHead eyebrow={eyebrow} title={title} subtitle={subtitle} />
          <Link to="/contact" className="text-link">
            Ask a question
          </Link>
        </div>

        <div className="faq-list">
          {items.map((faq, index) => {
            const isOpen = openIndex === index;
            return (
              <div key={faq.question} className={`faq-item ${isOpen ? 'open' : ''}`}>
                <button
                  type="button"
                  className="faq-question"
                  aria-expanded={isOpen}
                  aria-controls={`faq-answer-${index}`}
                  onClick={() => setOpenIndex(isOpen ? -1 : index)}
                >
                  {faq.question}
                  <FiPlus />
                </button>
                <div id={`faq-answer-${index}`} className="faq-answer" role="region">
                  <div>
                    <p>{faq.answer}</p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default FAQ;
